import { createCrudThunks } from '../../store/createCrudThunks';
import { callApi, type CallListParams } from './callApi';
import type { Call, CallCreatePayload, CallUpdatePayload } from './callTypes';

const thunks = createCrudThunks<Call, CallCreatePayload, CallUpdatePayload, CallListParams>(
  'calls',
  callApi,
);

export const callThunks = thunks;
export const {
  fetchAll: fetchCalls,
  fetchOne: fetchCall,
  create: createCall,
  update: updateCall,
  remove: deleteCall,
} = thunks;
